function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var defaultProps = {
  targets: '[data-elastic]',
  easing: 'cubic-bezier(.23,1,.32,1)',
  duration: [90, 750],
  intensity: 0.8,
  useNative: true,
  appleDevicesOnly: true
};
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var platform = isBrowser ? navigator.platform : '';
var ua = isBrowser ? navigator.userAgent : '';
var isMac = isBrowser && /Mac/.test(platform);
var isIOS = isBrowser && /iPhone|iPad|iPod/.test(platform) && !window.MSStream;
var hasNativeSupport = isIOS || isMac && /Safari/.test(ua) && !/Chrome/.test(ua);
var isAppleDevice = isIOS || isMac;

function arrayFrom(value) {
  return [].slice.call(value);
}

function createInnerWrap(el) {
  var div = document.createElement('div');
  div.setAttribute('data-elastic-wrapper', '');
  arrayFrom(el.childNodes).forEach(function (node) {
    div.appendChild(node);
  });
  el.appendChild(div);
  return div;
}

function getArrayOfElements(value) {
  if (typeof value === 'string') {
    return arrayFrom(document.querySelectorAll(value));
  } else if (value instanceof NodeList) {
    return arrayFrom(value);
  } else if (value instanceof Element) {
    return [value];
  }

  return [];
}

var TRANSITION_END = 'transitionend';
var RESET_TRANSFORM = 'translate3d(0,0,0)';

function createElasticScroll(el, props) {
  if (el._elasticScroll) {
    el._elasticScroll.disable();
  }

  var innerWrap = el.querySelector('[data-elastic-wrapper]') || createInnerWrap(el);
  var isTransitioning = false;
  var previousScrollTop = 0;
  var previousScrollLeft = 0;
  var scrollDirection = 'y';

  function onWheel(_ref) {
    var deltaX = _ref.deltaX,
        deltaY = _ref.deltaY;
    var offsetHeight = el.offsetHeight,
        offsetWidth = el.offsetWidth,
        scrollHeight = el.scrollHeight,
        scrollWidth = el.scrollWidth,
        scrollTop = el.scrollTop,
        scrollLeft = el.scrollLeft;

    if (previousScrollTop !== scrollTop) {
      scrollDirection = 'y';
    } else if (previousScrollLeft !== scrollLeft) {
      scrollDirection = 'x';
    }

    var isAtTop = scrollTop <= 0;
    var isAtBottom = scrollTop + offsetHeight >= scrollHeight;
    var isAtLeft = scrollLeft <= 0;
    var isAtRight = scrollLeft + offsetWidth >= scrollWidth;
    var hitLeftOrRightAndScrollingX = scrollDirection === 'x' && (isAtLeft || isAtRight);
    var hitTopOrBottomAndScrollingY = scrollDirection === 'y' && (isAtTop || isAtBottom);

    if (!hitLeftOrRightAndScrollingX && !hitTopOrBottomAndScrollingY) {
      isTransitioning = false;
      innerWrap.removeEventListener(TRANSITION_END, onBounceAwayTransitionEnd);
      innerWrap.removeEventListener(TRANSITION_END, onBounceBackTransitionEnd); // Prevent a bounce if already at the edge

      if (innerWrap.style.transform !== 'translate3d(0px, 0px, 0px)') {
        innerWrap.style.transition = 'none';
        innerWrap.style.transform = RESET_TRANSFORM;
      }
    }

    if (scrollTop === previousScrollTop && scrollLeft === previousScrollLeft) {
      // It's transitioning, or they are "stretching" the overflow.
      // TODO: implement stretching
      return;
    }

    previousScrollTop = scrollTop;
    previousScrollLeft = scrollLeft;

    if (!isTransitioning && (hitLeftOrRightAndScrollingX || hitTopOrBottomAndScrollingY)) {
      isTransitioning = true;
      innerWrap.addEventListener(TRANSITION_END, onBounceAwayTransitionEnd);
      innerWrap.style.transition = "transform ".concat(props.duration[0], "ms ").concat(props.easing); // Start transition away

      innerWrap.style.transform = "translate3d(".concat(hitLeftOrRightAndScrollingX ? props.intensity * -deltaX : 0, "px, ").concat(hitTopOrBottomAndScrollingY ? props.intensity * -deltaY : 0, "px, 0)");
    }
  }

  function onBounceAwayTransitionEnd() {
    innerWrap.removeEventListener(TRANSITION_END, onBounceAwayTransitionEnd);
    innerWrap.addEventListener(TRANSITION_END, onBounceBackTransitionEnd);
    innerWrap.style.transition = "transform ".concat(props.duration[1], "ms ").concat(props.easing); // Start transition back down

    innerWrap.style.transform = RESET_TRANSFORM;
  }

  function onBounceBackTransitionEnd() {
    innerWrap.removeEventListener(TRANSITION_END, onBounceBackTransitionEnd);
    isTransitioning = false;
  }

  function enable() {
    if (props.appleDevicesOnly && !isAppleDevice) {
      return;
    }

    if (props.useNative && hasNativeSupport) {
      el.style.webkitOverflowScrolling = 'touch';
    } else if (!props.useNative || !hasNativeSupport) {
      el.addEventListener('wheel', onWheel, {
        passive: true
      });
    }
  }

  function disable() {
    el.style.webkitOverflowScrolling = '';
    el.removeEventListener('wheel', onWheel, {
      passive: true
    });
  }

  enable();
  var elasticScroll = {
    el: el,
    props: props,
    enable: enable,
    disable: disable
  };
  el._elasticScroll = elasticScroll;
  return elasticScroll;
}

function elasticScroll(options) {
  var props = _extends({}, defaultProps, options);

  var instances = getArrayOfElements(props.targets).map(function (target) {
    return createElasticScroll(target, props);
  }).filter(Boolean);
  return props.targets instanceof Element ? instances[0] : instances;
}

elasticScroll.defaults = defaultProps;
export default elasticScroll;